/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */

export enum AuthType {
  sign_in,
  sign_up,
}
